import { createFileRoute } from '@tanstack/react-router';

import { FaqPage } from '~/modules/support';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.faqPage.pageTitle, { ns: 'support' });

export const Route = createFileRoute('/(main)/support/faq/')({
  component: FaqPage,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const SUPPORT_FAQ = buildRouteExport({ Route });
